import { Route, Router, Routes, useLocation } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { userStore } from "./stores";
//constant
import { homePageUrl } from "./helpers/Constants";
//style
import "./App.scss";
//Layouts
import Header from "./compnents/layouts/header/Header";
//Pages
// import Login from "./compnents/pages/login/Login";
import ComplaincerLogin from "./compnents/pages/login/ComplaincerLogin";
import Home from "./compnents/pages/home/Home";
//Header Component
import Dashboard from "./compnents/pages/dashboard/Dashboard";
import Reports from "./compnents/pages/reports/reports";
import UserProfile from "./compnents/pages/userprofile/UserProfile";
import Clients from "./compnents/pages/clients/Clients";
import Comments from "./compnents/pages/comments/Comments";
import Branch from "./compnents/pages/branch/Branch";
import ActivityLog from "./compnents/pages/activitylog/ActivityLog";
import ClientsEdit from "./compnents/pages/clients-edit/clients-edit";
import LegislationCompiled from "./compnents/pages/legislation-compiled/LegislationCompiled";
import ReportSubmittedSuccessfully from "./compnents/pages/report-submitted-successfully/ReportSubmittedSuccessfully";
//Legislation form
import Compiled from "./compnents/pages/legislation-forms/Compiled";
import CompiledWithException from "./compnents/pages/legislation-forms/CompiledWithException";
import NotCompiled from "./compnents/pages/legislation-forms/NotCompiled";
import NotApplicable from "./compnents/pages/legislation-forms/NotApplicable";
import CreateBranch from "./compnents/pages/create-branch/CreateBranch";
import CreateCompany from "./compnents/pages/create-company/CreateCompany";
import BranchDetail from "./compnents/pages/branch-detail/BranchDetail";
//Create user-profile
import ComplainceOfficer from "./compnents/pages/create-user-profile/ComplainceOfficer";
import Approver from "./compnents/pages/create-user-profile/Approver";
import Settings from "./compnents/pages/create-user-profile/Settings";
//Legislation
import LegislationList from "./compnents/pages/legislation-list/LegislationList";
import Auditor from "./compnents/pages/legislation/Auditor";
import Aboutus from "./compnents/pages/Aboutus/about";
import Compilancer from "./compnents/pages/legislation/Compilancer";
import ReportsApprover from "./compnents/pages/reports-approver/ReportsApprover";
import ApproversReports from "./compnents/pages/reports-approver/ApproversReports";
import AuditorTable from "./compnents/pages/super-admin/AuditorTable";
import CreateAuditor from "./compnents/pages/super-admin/CreateAuditor";
import ClientTable from "./compnents/pages/super-admin/ClientTable";
import Code from "./compnents/pages/code/Code";
import ProtectedRoutes from "./compnents/protectedRoutes";
import { AuthScreen } from "./compnents/pages/auth";
import SuperAdminDashboard from "./compnents/pages/dashboard/SuperDashboard";
import SuperAdminHeader from "./compnents/layouts/header/SuperAdminHeader";
import ComplianceOfficerHeader from "./compnents/layouts/header/ComplianceOfficerHeader";
import CompliancerLegislationList from "./compnents/pages/legislation-list/CompliancerLegislationList";
import UpdateBranch from "./compnents/pages/create-branch/UpdateBranch";
import ApproverSettings from "./compnents/pages/create-user-profile/ApproverSetting";
import CreateReport from "./compnents/pages/reports/createReportFromTemplate";
import AuditorCompiled from "./compnents/pages/compliance/AuditorCompliance";
import ApproverHeader from "./compnents/layouts/header/ApproverHeader";
import ApproverDashboard from "./compnents/pages/dashboard/ApproverDashboard";
// import ApproverComments from "./compnents/pages/comments/ApproverComments";
import LegislationListViews from "./compnents/pages/legislation-list-view/LegislationListView";
import CompliancerCompiled from "./compnents/pages/compliance/CompliancerCompliance";
import CompliancerReports from "./compnents/pages/reports/compliancereports";
import CompliancerCompiledView from "./compnents/pages/compliance-view/CompliancerComplianceView";
import CompliancerLegislationListView from "./compnents/pages/legislation-list-view/CompliancerLegislationListView";
import CompilancerView from "./compnents/pages/legislation-view/CompilancerView";
import ApproverLegislationListViews from "./compnents/pages/legislation-list-view/ApproverLegislationListView";
import Toaster from "./helpers/Toaster";
import UploadReport from "./compnents/pages/upload-report/UploadReport";
import AuditorViews from "./compnents/pages/legislation-view/AuditorView";
import AuditorCompiledViews from "./compnents/pages/compliance-view/AuditorComplianceView";
import ApproverViews from "./compnents/pages/legislation-view/ApproverAuditorView";
import ApproverCompiledViews from "./compnents/pages/compliance-view/ApproverComplianceView";
import ComplainceOfficerUpdate from "./compnents/pages/create-user-profile/ComplainceOfficer-edit";
import UpdateApprover from "./compnents/pages/create-user-profile/Approver-edit";
import { GlobalContext } from './contexts/GlobalContext'
import Report from "./compnents/pages/super-admin/Report";
import User from "./compnents/pages/super-admin/User";
import Company from "./compnents/pages/super-admin/Company";
import Activity from "./compnents/pages/super-admin/Activity";
import ActionAuditor from "./compnents/pages/Action/Action";
import CommentsCompliencer from "./compnents/pages/comments/CommentsCompliencer";
import Action from "./compnents/pages/compliencer-Action/Action";
import ActionApprover from "./compnents/pages/ActionApprover/ActionApprover";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import NewDashbord from "./compnents/pages/dashboard/NewDashboard";

function App() {
  const location = useLocation();
  let [hideHeader, setHideHeader] = useState(false);
  let [header, setHeader] = useState("");
  const [role, setRole] = useState();
  const [notification, setNotification] = useState([])
  const [roomId, setRoomId] = useState('')

  useEffect(() => {
    let myLocation = location.pathname;
    if (
      myLocation.includes("login") ||
      myLocation.includes("sign-in") ||
      myLocation.includes("code")
    ) {
      setHideHeader(true);
    }
    if (myLocation.includes("super-admin")) {
      setHideHeader(false);
      setHeader("super-admin");
    } else if (myLocation.includes("auditor")) {
      setHideHeader(false);
      setHeader("auditor");
    } else if (myLocation.includes("compliancer")) {
      setHideHeader(false);
      setHeader("compliancer");
    } else if (myLocation.includes("approver")) {
      setHideHeader(false);
      setHeader("approver");
    }
  }, [location]);

  return (

    <GlobalContext.Provider
      value={{ notification, setNotification, roomId, setRoomId }}
    >
      <React.Fragment>
        {header === 'super-admin' ? (
          <SuperAdminHeader hideHeader={hideHeader} />
        ) : header === 'auditor' ? (
          <Header hideHeader={hideHeader} />
        ) : header === 'compliancer' ? (
          <ComplianceOfficerHeader hideHeader={hideHeader} />
        ) : (
          <ApproverHeader hideHeader={hideHeader} />
        )}
        <ToastContainer position="bottom-right" />

        <Routes>
          {/* <Route exact path={``} element={<Home />} /> */}
          <Route path="/" element={<ProtectedRoutes />}>
            <Route path="" element={<ProtectedRoutes roleRequired="1" />}>
              <Route
                exact
                path={`super-admin`}
                element={<SuperAdminDashboard />}
              />
              <Route
                exact
                path={`super-admin/auditor`}
                element={<AuditorTable />}
              />
              {/* SuperAdminDashboard */}
              <Route
                exact
                path={`super-admin/create-auditor`}
                element={<CreateAuditor />}
              />
              <Route
                exact
                path={`super-admin/super-report`}
                element={<Report />}
              />
              <Route
                exact
                path={`super-admin/super-user`}
                element={<User />}
              />
              <Route
                exact
                path={`super-admin/super-company`}
                element={<Company />}
              />
              <Route
                exact
                path={`super-admin/super-activelog`}
                element={<Activity />}
              />
              <Route
                exact
                path={`super-admin/client-table`}
                element={<ClientTable />}
              />
            </Route>
            <Route path="/" element={<ProtectedRoutes roleRequired="2" />}>
              <Route exact path={`auditor`} element={<Home />} />
              <Route exact path={`auditor/dashboard`} element={<Dashboard />} />
              <Route exact path={`auditor/reports`} element={<Reports />} />

              <Route
                exact
                path={`auditor/user-profile`}
                element={<UserProfile />}
              />
              <Route
                exact
                path={`auditor/upload-report`}
                element={<UploadReport />}
              />
              <Route exact path={`auditor/clients`} element={<Clients />} />
              <Route exact path={`auditor/comments`} element={<Comments />} />
              <Route exact path={`auditor/branch`} element={<Branch />} />
              <Route
                exact
                path={`auditor/activity-log`}
                element={<ActivityLog />}
              />
              <Route
                exact
                path={`auditor/action`}
                element={<ActionAuditor />}
              />
              <Route
                path={`auditor/legislation-list/:reportId`}
                element={<LegislationList />}
              />
              <Route
                path={`auditor/view/legislation-list/:reportId`}
                element={<LegislationListViews />}
              />
              <Route
                exact
                path={`auditor/legislation-list/:reportId/:legislationId`}
                element={<Auditor />}
              />
              <Route
                exact
                path={`auditor/legislation-list/:reportId/:legislationId/:complianceId`}
                element={<AuditorCompiled />}
              />
              <Route
                path={`auditor/view/legislation-list/:reportId`}
                element={<LegislationListViews />}
              />
              <Route
                exact
                path={`auditor/view/legislation-list/:reportId/:legislationId`}
                element={<AuditorViews />}
              />
              <Route
                exact
                path={`auditor/view/legislation-list/:reportId/:legislationId/:complianceId`}
                element={<AuditorCompiledViews />}
              />
              <Route
                exact
                path={`auditor/legislation/complaincer`}
                element={<Compilancer />}
              />
              <Route
                exact
                path={`auditor/legislation-compiled`}
                element={<LegislationCompiled />}
              />
              <Route
                exact
                path={`auditor/legislation-form/compiled`}
                element={<Compiled />}
              />
              <Route
                exact
                path={`auditor/legislation-form/not-compiled`}
                element={<NotCompiled />}
              />
              <Route
                exact
                path={`auditor/legislation-form/not-applicable`}
                element={<NotApplicable />}
              />
              <Route
                exact
                path={`auditor/legislation-form/compiled-with-exception`}
                element={<CompiledWithException />}
              />
              <Route
                exact
                path={`auditor/create-branch`}
                element={<CreateBranch />}
              />
              <Route
                exact
                path={`auditor/branch-edit/:id`}
                element={<UpdateBranch />}
              />
              <Route
                exact
                path={`auditor/create-company`}
                element={<CreateCompany />}
              />
              <Route
                path={`auditor/branch-detail/:id`}
                element={<BranchDetail />}
              />
              <Route
                path={`auditor/clients-edit/:id`}
                element={<ClientsEdit />}
              />
              <Route
                exact
                path={`auditor/create-user-profile/complaincer-officer`}
                element={<ComplainceOfficer />}
              />
              <Route
                exact
                path={`auditor/complaincer-officer/:id`}
                element={<ComplainceOfficerUpdate />}
              />
              <Route
                exact
                path={`auditor/create-user-profile/approver`}
                element={<Approver />}
              />
              <Route
                exact
                path={`auditor/approver/:id`}
                element={<UpdateApprover />}
              />
              <Route
                exact
                path={`auditor/create-user-profile/settings`}
                element={<ApproverSettings />}
              />
              <Route
                exact
                path={`auditor/create-report`}
                element={<CreateReport />}
              />
            </Route>
            {/* <Route
              exact
              path={`auditor/create-user-profile/settings`}
              element={<Settings />}
            />
          </Route> */}
            <Route path="/" element={<ProtectedRoutes roleRequired="3" />}>

             <Route
                exact
                path={`compliancer/new-dashboard`}
                element={<NewDashbord />}
              />
              <Route
                exact
                path={`compliancer/dashboard`}
                element={<NewDashbord />}
              />
              <Route
                exact
                path={`compliancer/legislation-list`}
                element={<CompliancerLegislationList />}
              />
              <Route
                exact
                path={`compliancer/compliencer-comments`}
                element={<CommentsCompliencer />}
              />
              <Route
                exact
                path={`compliancer/compliencer-action`}
                element={<Action />}
              />
              <Route
                exact
                path={`compliancer/legislation-compiled`}
                element={<LegislationCompiled />}
              />
              <Route
                exact
                path={`compliancer/report-submitted-successfully`}
                element={<ReportSubmittedSuccessfully />}
              />
              <Route
                exact
                path={`compliancer/legislation-form/compiled`}
                element={<Compiled />}
              />
              <Route
                exact
                path={`compliancer/legislation-form/not-compiled`}
                element={<NotCompiled />}
              />
              <Route
                exact
                path={`compliancer/legislation-form/not-applicable`}
                element={<NotApplicable />}
              />
              <Route
                exact
                path={`compliancer/legislation-form/compiled-with-exception`}
                element={<CompiledWithException />}
              />
              <Route
                exact
                path={`compliancer/view/legislation-list/:reportId/:legislationId/:complianceId`}
                element={<CompliancerCompiledView />}
              />
              <Route
                path={`compliancer/view/legislation-list/:reportId`}
                element={<CompliancerLegislationListView />}
              />
              <Route
                exact
                path={`compliancer/view/legislation-list/:reportId/:legislationId`}
                element={<CompilancerView />}
              />
              <Route
                exact
                path={`compliancer/reports`}
                element={<CompliancerReports />}
              />
              <Route
                exact
                path={`compliancer/reports`}
                element={<CompliancerReports />}
              />
              <Route
                path={`compliancer/legislation-list/:reportId`}
                element={<CompliancerLegislationList />}
              />
              
              <Route
                exact
                path={`compliancer/legislation-list/:reportId/:legislationId`}
                element={<Compilancer />}
              />
              <Route
                exact
                path={`compliancer/legislation-list/:reportId/:legislationId/:complianceId`}
                element={<CompliancerCompiled />}
              />
            </Route>
            <Route path="/" element={<ProtectedRoutes roleRequired="4" />}>
              <Route
                exact
                path={`approver/reports-approver`}
                element={<ReportsApprover />}
              />
              <Route
                path={`approver/view/legislation-list/:reportId`}
                element={<ApproverLegislationListViews />}
              />
              <Route
                exact
                path={`approver/view/legislation-list/:reportId/:legislationId`}
                element={<ApproverViews />}
              />
              <Route
                exact
                path={`approver/view/legislation-list/:reportId/:legislationId/:complianceId`}
                element={<ApproverCompiledViews />}
              />
              <Route
                exact
                path={`approver/dashboard`}
                element={<ApproverDashboard />}
              />
              {/* <Route
                exact
                path={`approver/comments`}
                element={<ApproverComments />}
              /> */}

              <Route
                exact
                path={`approver/actionapprover`}
                element={<ActionApprover />}
              />
              <Route exact path={`toaster`} element={<Toaster />} />
              {/* <Route
                exact
                path={`approvers-reports`}
                element={<ApproversReports />}
              /> */}
            </Route>
          </Route>
          <Route
            exact
            path={`sign-in`}
            element={<AuthScreen userStore={userStore} />}
          />
          <Route
            exact
            path={`about-us`}
            element={<Aboutus/>}
          />
          <Route exact path={`code`} element={<Code />} />
        </Routes>
      </React.Fragment>
    </GlobalContext.Provider>);
}
export default App;
